export const baseURL = process.env.REACT_APP_THINGSBOARD;
export const smartfactoryURL = process.env.REACT_APP_BACKEND;
export const FAUST_URL = process.env.REACT_APP_FAUST;

export const CONSTANTS = {
    SHIFT: {
        STARTHOUR: 8, ENDHOUR: 8,
        STARTMIN: 30, ENDMIN: 30,
        STARTSEC: 1, ENDSEC: 0
    }
}